export const paperStyle = {
	background: "transparent",
	boxShadow: "none",
	overflow: "visible"
};
